import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem("token")
      ? sessionStorage.getItem("token")
      : "",
    active: sessionStorage.getItem("active")
      ? sessionStorage.getItem("active")
      : "",
    ProductId: sessionStorage.getItem("ProductId")
      ? sessionStorage.getItem("ProductId")
      : "",
  },
  mutations: {
    SetProductId(state, id) {
      state.ProductId = id;
      sessionStorage.setItem("ProductId", id);
    },
    setActive(state, active) {
      state.active = active;
    },
    setToken(state, token) {
      state.token = token;
      sessionStorage.setItem("token", token);
    },
    delToken(state) {
      state.token = "";
      sessionStorage.removeItem("token");
    },
  },
  actions: {},
  modules: {},
});
